<template>
  <div
    id="not-found"
    class="text-center"
  >
    <h1>
      <i class="ti ti-fw ti-2x ti-warning" /><br>
      {{ $t('error.not_found.title') }}
    </h1>
    <p>{{ $t('error.not_found.text') }}</p>
  </div>
</template>

<script>
  export default {
    name: 'NotFoundView',
  };
</script>

<style lang="scss" scoped>
</style>
